/* ========================================
   VOE SLIM LANDING - SHOPIFY JS
   Theme: Dawn 15.4.0
   ======================================== */

document.addEventListener('DOMContentLoaded', function() {
    
    // ========================================
    // FLOATING CTA VISIBILITY
    // ========================================
    const floatingCta = document.getElementById('voeFloatingCta');
    
    if (floatingCta) {
        window.addEventListener('scroll', function() {
            if (window.pageYOffset > 600) {
                floatingCta.classList.add('visible');
            } else {
                floatingCta.classList.remove('visible');
            }
        });
    }

    // ========================================
    // FAQ ACCORDION
    // ========================================
    const faqQuestions = document.querySelectorAll('.voe-faq__question');
    
    faqQuestions.forEach(function(question) {
        question.addEventListener('click', function() {
            const faqItem = question.parentElement;
            const isActive = faqItem.classList.contains('active');
            
            // Close all FAQ items
            document.querySelectorAll('.voe-faq__item').forEach(function(item) {
                item.classList.remove('active');
            });
            
            // Open clicked item if it wasn't active
            if (!isActive) {
                faqItem.classList.add('active');
            }
        });
    });

    // ========================================
    // SMOOTH SCROLL FOR ANCHOR LINKS
    // ========================================
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    
    anchorLinks.forEach(function(anchor) {
        anchor.addEventListener('click', function(e) {
            const targetId = this.getAttribute('href');
            if (targetId === '#') return;
            
            const target = document.querySelector(targetId);
            
            if (target) {
                e.preventDefault();
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });

    // ========================================
    // ANIMATION ON SCROLL (INTERSECTION OBSERVER)
    // ========================================
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
            }
        });
    }, observerOptions);

    // Elements to animate
    const animatedElements = document.querySelectorAll(
        '.voe-producto-card, .voe-ciencia__card, .voe-testimonio-card, .voe-esparati__item, .voe-quees__icon-item'
    );
    
    animatedElements.forEach(function(el) {
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        el.style.transition = 'all 0.6s ease';
        observer.observe(el);
    });

});
